import { ImageContainer, Image } from './Common'

import HeightFillingImage from 'components/Common/HeightFillingImage'
import GoogleCardImage from 'tripPlanner/components/ItemCard/Common/GoogleCardImage'
import type { Place } from 'tripPlanner/types/common'
import { maybePlaceId } from 'tripPlanner/utils'

interface Props {
  place: Place
  tripId: string
  tripItemId: string
  imgId?: string
  imgURL?: string
}

export default function SummaryCardImage({
  place,
  tripId,
  tripItemId,
  imgId,
  imgURL,
}: Props) {
  if (imgURL && imgURL.length > 0) {
    return (
      <ImageContainer>
        <Image src={imgURL} />
      </ImageContainer>
    )
  }
  if (imgId && imgId.length > 0) {
    return (
      <ImageContainer>
        <HeightFillingImage id={imgId} />
      </ImageContainer>
    )
  }
  const googlePlaceId = maybePlaceId(place)
  if (googlePlaceId) {
    return (
      <ImageContainer>
        <GoogleCardImage
          placeId={googlePlaceId}
          title={place.name}
          tripId={tripId}
          tripItemId={tripItemId}
        />
      </ImageContainer>
    )
  }

  if (place.photoUrl) {
    return (
      <ImageContainer>
        <Image src={place.photoUrl} />
      </ImageContainer>
    )
  }

  return null
}
